// extracted by mini-css-extract-plugin
export default {"task-list-container":"styles_task-list-container__9X-F4","task-list-header":"styles_task-list-header__QtnW9","task-list":"styles_task-list__OqxnM"};